import Question from './question';
var Step = /** @class */ (function () {
    function Step(questions) {
        this.questions = [];
        this.parseData(questions);
    }
    Object.defineProperty(Step.prototype, "questionList", {
        get: function () {
            return this.questions;
        },
        enumerable: false,
        configurable: true
    });
    Step.prototype.isAsked = function (sessionAnswers) {
        return this.questions.some(function (question) { return question.isAsked(sessionAnswers); });
    };
    Step.prototype.parseData = function (questions) {
        this.questions = questions.map(function (question) { return new Question(question); });
    };
    return Step;
}());
export default Step;
